import * as actionTypes from "../constants/actionTypes";

const initialState = {
    importing: false,
    imported: [],
    errorCode: null,
    aborting: false,
    aborted: false,
    progress: 0,
    task: null
};

/**
 * Structure of import data store:
 * - importing {Boolean}    - if true, data are currently importing
 * - imported {Boolean}     - if true, data were imported correctly
 * - errorCode {String}     - if not null, there was an error during import
 * - aborting {Boolean}     - if true, import is currently aborting
 * - aborted {Boolean}      - if true, import was aborted
 * - progress {Number}      - progress of file import
 * - task {String}          - name of importing action
 */
export const importDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.PRICE_DATA_IMPORTING_START:
        case actionTypes.CUSTOM_DATA_IMPORTING_START:
            return {
                ...state,
                importing: true,
                imported: [],
                aborting: false,
                aborted: false
            };
        case actionTypes.PRICE_DATA_IMPORTING_END:
        case actionTypes.CUSTOM_DATA_IMPORTING_END:
            return {
                ...state,
                importing: false,
                imported: action.payload.imported ?? [],
                errorCode: action.payload.errorCode
            };
        case actionTypes.CUSTOM_DATA_IMPORTING_ABORTED:
            return {
                ...state,
                importing: false,
                aborting: false,
                aborted: true
            };
        case actionTypes.PRICE_DATA_ABORT_IMPORTING:
        case actionTypes.CUSTOM_DATA_ABORT_IMPORTING:
            return {
                ...state,
                aborting: true
            };
        case actionTypes.CUSTOM_DATA_SAVE_PROGRESS:
            return {
                ...state,
                progress: action.payload.progress,
                task: action.payload.task
            };
        default:
            return state;
    }
};
